const SITE_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "HVACBusiness",
  name: "Central Air Depot",
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/logo-badge.png`,
  image: `${SITE_URL}/og-image.jpg`,
  telephone: "+1-786-512-1929",
  email: "info@centralairdepot.com",
  foundingDate: "1998",
  description:
    "South Florida AC service, repair, installation and maintenance since 1998. 24/7 emergency booking — call any time, our system takes your request, and a technician is dispatched after a $200 prepaid emergency booking fee, applied toward your repair.",
  areaServed: [
    { "@type": "AdministrativeArea", name: "Miami-Dade County, FL" },
    { "@type": "AdministrativeArea", name: "Broward County, FL" },
    { "@type": "AdministrativeArea", name: "Palm Beach County, FL" },
  ],
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
    description: "24/7 emergency booking",
  },
  sameAs: ["https://share.google/Z6ZUZcpyMPd5DzWl2"],
};

// Static, build-time content only — never includes user input.
const JSON_LD = { __html: JSON.stringify(SCHEMA) };

export const BusinessJsonLd = () => (
  <script type="application/ld+json" dangerouslySetInnerHTML={JSON_LD} />
);
